import {
  ProductState,
  ProductStateStatus,
} from '@/shared/api/protocol-ts/api/billing_new/dto_product_new_pb';

// NOTE: A product is defined as active only when it holds an 'active' status and its effective start date is not in the future, accounting for subscriptions with scheduled or deferred activation
export const isProductActive = (product: ProductState) =>
  product.Status === ProductStateStatus.ProductStateStatusActive &&
  (!product.Start || product.Start.toDate() <= new Date());
